export default __webpack_public_path__ + "static/Lara-e8f4de6996c004539e99906fd82432f56b0f202b107ccdd8fa4a3821cff5675f.svg";